import monkeyPatch from "./monkeyPatch.js";

/**
 * Erweitert alle Javascript-Strings um einen Satz von Hilfsmethoden (Monkeypatching).
 * Weitere String-Methoden finden sich in lodash.
 */
monkeyPatch(String.prototype, {

    /**
     * Garantiert, dass der String mit part anfängt.
     * @example
     * 'Hallo'.ensureLeft('/') => '/Hallo'
     * '/Hallo'.ensureLeft('/') => '/Hallo'
     */
    ensureLeft(part) {
        if (this.startsWith(part)) {
            return this;
        } else {
            return part + this;
        }
    },

    /**
     * Garantiert, dass der String mit part endet.
     * @example
     * 'Hallo'.ensureRight('/') => 'Hallo/'
     * 'Hallo/'.ensureRight('/') => 'Hallo/'
     */
    ensureRight(part) {
        if (this.endsWith(part)) {
            return this;
        } else {
            return this + part;
        }
    },

    /**
     * Testet, ob der String mit part anfängt.
     */
    startsWith(part) {
        return this.indexOf(part) === 0;
    },

    /**
     * Testet, ob der String part enthält.
     */
    contains(part) {
        return this.indexOf(part) !== -1;
    },

    /**
     * Testet, ob der String mit part endet.
     */
    endsWith(part) {
        return this.indexOf(part) === this.length - part.length;
    },

    /**
     * Testet, ob der String leer ist
     */
    isEmpty() {
        return this.length === 0;
    },

    /**
     * Testet, ob der String leer ist oder nur aus Leerzeichen besteht
     */
    isBlank() {
        return this.trim().length === 0;
    },

    /**
     * Gibt den String in umgekehrter Reihenfolge zurück
     */
    reverse() {
        return this.split('').reverse().join('');
    },

    /**
     * Schneidet alle Vorkommen von part von links ab.
     * @example
     * 'aaabaaa'.ltrim('a') => 'baaa'
     */
    ltrim(part) {
        var s = this;
        while (s.startsWith(part)) {
            s = s.substring(part.length);
        }
        return s;
    },

    /**
     * Schneidet alle Vorkommen von part von rechts ab.
     * @example
     * 'aaabaaa'.rtrim('a') => 'aaab'
     */
    rtrim(part) {
        var s = this;
        while (s.endsWith(part)) {
            s = s.substring(0, s.length - part.length);
        }
        return s;
    },

    /**
     * Gibt den Teilstring vor dem ersten Auftauchen von part zurück
     * @example
     * 'pfad/unterpfad/endpfad'.substringBefore('/') => 'pfad'
     * 'pfad'.substringBefore('/') => 'pfad'
     */
    substringBefore(part) {
        var i = this.indexOf(part);
        if (i != -1) {
            return this.slice(0, i);
        } else {
            return this;
        }
    },

    /**
     * Gibt den Teilstring vor dem letzten Auftauchen von part zurück
     * @example
     * 'pfad/unterpfad/endpfad'.substringBefore('/') => 'pfad/unterpfad'
     * 'pfad'.substringBefore('/') => 'pfad'
     */
    substringBeforeLast(part) {
        var i = this.lastIndexOf(part);
        if (i != -1) {
            return this.slice(0, i);
        } else {
            return this;
        }
    },

    /**
     * Gibt den Teilstring nach dem ersten Auftauchen von part zurück
     * @example
     * 'pfad/unterpfad/endpfad'.substringAfter('/') => 'unterpfad/endpfad'
     * 'pfad'.substringBefore('/') => 'pfad'
     */
    substringAfter(part) {
        var i = this.indexOf(part);
        if (i != -1) {
            return this.slice(i + part.length, this.length);
        } else {
            return this;
        }
    },

    /**
     * Gibt den Teilstring nach dem letzten Auftauchen von part zurück
     * @example
     * 'pfad/unterpfad/endpfad'.substringAfterLast('/') => 'endpfad'
     * 'pfad'.substringBefore('/') => 'pfad'
     */
    substringAfterLast(part) {
        var i = this.lastIndexOf(part);
        if (i != -1) {
            return this.slice(i + part.length, this.length);
        } else {
            return this;
        }
    },

    /**
     * Gibt den Teilstring zwischen den Teilstrings left und right zurück
     * @example
     * 'a(b)c'.substringBetween('(',')') => 'b'
     */
    substringBetween(left,right) {
        var l = this.indexOf(left);
        var r = this.lastIndexOf(right);
        if (l < r && l > -1) {
            return this.slice(l+1, r);
        } else {
            return this;
        }
    },

});